import cx from 'classnames';

import { updateUserPreference } from 'actions/user';
import SwitchButton from 'components/bellAlerts/partials/SwitchButton';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import i18n from 'i18n/config';
import { showOrderOnChartSelector } from 'selectors/otherSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';

import styles from './ChartOrderbookTab.module.scss';

const showBuySellButtonOnChart = i18n.t(
  'account:tradeSettings.generalList.showBuySellButtonOnChart'
);

const ShowBuySellButtonOnChartSwitch = () => {
  const showOnChartScreen: boolean = useAppSelector(showOrderOnChartSelector);
  const dispatch = useAppDispatch();
  const handleChange = () => {
    const eventName = showOnChartScreen
      ? MIXPANEL_EVENT_NAMES.MOBILE_CHART.BOOK_ORDER_BUTTON_HIDDEN
      : MIXPANEL_EVENT_NAMES.MOBILE_CHART.BOOK_ORDER_BUTTON_SHOWN;

    dispatch(
      updateUserPreference(
        { preferences: { showOrderOnChart: !showOnChartScreen } },
        { disable_notification: false }
      )
    );
    trackMixpanelEvent(eventName, {
      source: 'Charts/Book_Order',
    });
  };

  return (
    <SwitchButton
      data-testid="showBuySellButtonOnChart"
      className={cx('flex-set flex--content-between', styles.settingsContentItemSwitch)}
      buttonText={showBuySellButtonOnChart}
      checked={showOnChartScreen}
      onChange={handleChange}
      classes={{
        root: styles.switchRoot,
        track: styles.switchTrack,
        thumb: styles.switchThumb,
        switchBase: styles.switchBase,
        checked: styles.switchChecked,
        label: styles.switchLabel,
      }}
      disableRipple
    />
  );
};

export default ShowBuySellButtonOnChartSwitch;
